import {ActionTree} from "vuex";
import {DuplicateItem, DuplicatesState} from "@/store/settings/duplicates/types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<DuplicatesState, RootState> = {
  getDuplicates: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/duplicates', params: data})
        .then(resp => {
          commit('setDuplicates', resp.data?.duplicate_rules);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getDuplicateItem: ({commit, dispatch},id) => {
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/duplicates/${id}`})
        .then((resp:any) => {
          let duplicateItem = <DuplicateItem>resp.data;
          duplicateItem.id = id;
          commit('setDuplicateItem', duplicateItem);
          resolve(duplicateItem)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  saveDuplicate: ({commit, dispatch}, data: DuplicateItem) => {
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/duplicates/' + (data.id ?? ''),
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getDuplicates');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
  deleteDuplicate: ({commit, dispatch}, data: DuplicateItem) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/duplicates/${data.id}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getDuplicates');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
}